// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#send-button {
  flex-shrink: 0;
  border: 0px solid;
  width: 25px !important;
  height: 25px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  padding: 0 !important;
  background-color: transparent !important;
  outline: none !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

#send-button img {
  width: 100% !important;
  height: 100% !important;
  outline: none !important;
  cursor: pointer !important;
}

#magicform-label {
  font-size: 0.5rem !important;
  font-family: sans-serif !important;
  color: rgb(82, 47, 170) !important;
  /* margin-top: calc(3rem + 8px); */
  width: 100% !important;
  text-align: center !important;
}

#magicform-label p {
  font-size: 8px !important;
  margin: 8px 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/InputField/InputField.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;EACxC,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":["#send-button {\n  flex-shrink: 0;\n  border: 0px solid;\n  width: 25px !important;\n  height: 25px !important;\n  margin-left: 5px !important;\n  margin-right: 5px !important;\n  padding: 0 !important;\n  background-color: transparent !important;\n  outline: none !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n#send-button img {\n  width: 100% !important;\n  height: 100% !important;\n  outline: none !important;\n  cursor: pointer !important;\n}\n\n#magicform-label {\n  font-size: 0.5rem !important;\n  font-family: sans-serif !important;\n  color: rgb(82, 47, 170) !important;\n  /* margin-top: calc(3rem + 8px); */\n  width: 100% !important;\n  text-align: center !important;\n}\n\n#magicform-label p {\n  font-size: 8px !important;\n  margin: 8px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `send-button`;
export { _1 as "send-button" };
var _2 = `magicform-label`;
export { _2 as "magicform-label" };
export default ___CSS_LOADER_EXPORT___;
